import { FirstDA, Diversification } from '@app/models/carnet-liaison';
import { DIVERSIFICATION_GROUPES, SURVEILLANCE_SYMPTOMES_LABELS } from './carnet-liaison.constants';
import moment from 'moment';

export function getItemsToShow(
  obj: Record<string, boolean>,
  labels: Record<string, string>,
  firstDA: FirstDA | null | undefined,
  daSection: keyof FirstDA,
  fieldName: string,
  selectedDate: Date | null
): { label: string; key: string }[] {
  const result: { label: string; key: string }[] = [];
  for (const key of Object.keys(labels)) {
    if (obj?.[key] === true) {
      result.push({ key, label: labels[key] });
    } else {
      const firstDateStr = getFirstDate(firstDA, daSection, fieldName, key);
      if (firstDateStr && selectedDate) {
        const d = moment(firstDateStr).toDate();
        if (d <= selectedDate) result.push({ key, label: labels[key] });
      }
    }
  }
  return result;
}

export function getActiveCheckboxKeyedLabels(
  obj: Record<string, boolean>,
  labels: Record<string, string>
): { label: string; key: string }[] {
  if (!obj) return [];
  return Object.entries(obj)
    .filter(([, v]) => v === true)
    .map(([k]) => ({ key: k, label: labels[k] || k }));
}

export function getRadioKeyedLabel(
  obj: Record<string, boolean>,
  labels: Record<string, string>
): { label: string; key: string } | null {
  if (!obj) return null;
  const found = Object.entries(obj).find(([, v]) => v === true);
  if (!found) return null;
  return { key: found[0], label: labels[found[0]] ?? found[0] };
}

export function getFirstDate(
  firstDA: FirstDA | null | undefined,
  daSection: keyof FirstDA,
  fieldName: string,
  optionKey: string
): string | null {
  const entries = firstDA?.[daSection];
  if (!entries) return null;
  const searchOption = `${fieldName}#${optionKey}`;
  return entries.find(e => e.option === searchOption)?.date ?? null;
}

export function formatFirstDate(dateStr: string): string {
  if (!dateStr) return '';
  const d = moment(dateStr).toDate();
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
}

export function getSurveillanceSymptomes(surv: Record<string, unknown>): string[] {
  return Object.keys(SURVEILLANCE_SYMPTOMES_LABELS)
    .filter(key => surv[key] === true)
    .map(key => SURVEILLANCE_SYMPTOMES_LABELS[key]);
}

export function getDiversificationGroupsKeyed(
  div: Diversification,
  firstDA: FirstDA | null = null,
  selectedDate: Date | null = null
): { label: string; theme: string; items: { label: string; key: string }[] }[] {
  const d = div?.dispoDiversification;
  if (!d) return [];
  return DIVERSIFICATION_GROUPES
    .map(g => ({
      label: g.label,
      theme: g.theme,
      items: getItemsToShow(
        (d as Record<string, Record<string, boolean>>)[g.theme] ?? {},
        g.labelsMap,
        firstDA,
        'DA_diversification',
        g.theme,
        selectedDate
      ),
    }))
    .filter(g => g.items.length > 0);
}
